function Slider() {
  return (
    <div className="mfn-main-slider" id="mfn-rev-slider">
      <div
        id="rev_slider_1_1_wrapper"
        className="rev_slider_wrapper fullwidthbanner-container"
        style={{
          margin: "0px auto",
          backgroundColor: "transparent",
          padding: 0,
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        <div
          id="rev_slider_1_1"
          className="rev_slider fullwidthabanner"
          style={{ display: "none" }}
          data-version="5.2.5"
        >
          <ul>
            <li
              data-index="rs-1"
              data-transition="fade"
              data-slotamount="default"
              data-hideafterloop={0}
              data-hideslideonmobile="off"
              data-easein="default"
              data-easeout="default"
              data-masterspeed={300}
              data-rotate={0}
              data-saveperformance="off"
              data-title="Slide"
              data-param1=""
              data-param2=""
              data-param3=""
              data-param4=""
              data-param5=""
              data-param6=""
              data-param7=""
              data-param8=""
              data-param9=""
              data-param10=""
              data-description=""
            >
              <img
                src="content/architect2/images/home_architect2_slider1.jpg"
                title="home_architect2_slider1"
                width={1920}
                height={800}
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                className="rev-slidebg"
              />
              <div
                className="tp-caption   tp-resizeme"
                id="slide-1-layer-2"
                data-x="right"
                data-hoffset={50}
                data-y=""
                data-width="['auto']"
                data-height="['auto']"
                data-transform_idle="o:1;"
                data-transform_in="x:right;s:700;e:Power2.easeInOut;"
                data-transform_out="opacity:0;s:300;"
                data-start={700}
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style={{
                  zIndex: 5,
                  whiteSpace: "nowrap",
                  fontSize: 28,
                  lineHeight: 50,
                  fontWeight: 700,
                  color: "rgba(255, 255, 255, 1.00)",
                  fontFamily: "Raleway",
                  backgroundColor: "rgba(0, 0, 0, 1.00)",
                  padding: "0 20px 0px 20px",
                }}
              >
                BETROUWBARE PARTNER
              </div>
            </li>
            <li
              data-index="rs-2"
              data-transition="fade"
              data-slotamount="default"
              data-hideafterloop={0}
              data-hideslideonmobile="off"
              data-easein="default"
              data-easeout="default"
              data-masterspeed={300}
              data-rotate={0}
              data-saveperformance="off"
              data-title="Slide"
              data-param1=""
              data-param2=""
              data-param3=""
              data-param4=""
              data-param5=""
              data-param6=""
              data-param7=""
              data-param8=""
              data-param9=""
              data-param10=""
              data-description=""
            >
              <img
                src="content/architect2/images/home_architect2_slider2.jpg"
                title="home_architect2_slider2"
                width={1920}
                height={800}
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                className="rev-slidebg"
              />
              <div
                className="tp-caption   tp-resizeme"
                id="slide-2-layer-2"
                data-x="right"
                data-hoffset={50}
                data-y=""
                data-width="['auto']"
                data-height="['auto']"
                data-transform_idle="o:1;"
                data-transform_in="x:right;s:700;e:Power2.easeInOut;"
                data-transform_out="opacity:0;s:300;"
                data-start={700}
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style={{
                  zIndex: 5,
                  whiteSpace: "nowrap",
                  fontSize: 28,
                  lineHeight: 50,
                  fontWeight: 700,
                  color: "rgba(255, 255, 255, 1.00)",
                  fontFamily: "Raleway",
                  backgroundColor: "rgba(0, 0, 0, 1.00)",
                  padding: "0 20px 0px 20px",
                }}
              >
                OPLOSSINGEN OP MAAT
              </div>
            </li>
            <li
              data-index="rs-3"
              data-transition="fade"
              data-slotamount="default"
              data-hideafterloop={0}
              data-hideslideonmobile="off"
              data-easein="default"
              data-easeout="default"
              data-masterspeed={300}
              data-rotate={0}
              data-saveperformance="off"
              data-title="Slide"
              data-param1=""
              data-param2=""
              data-param3=""
              data-param4=""
              data-param5=""
              data-param6=""
              data-param7=""
              data-param8=""
              data-param9=""
              data-param10=""
              data-description=""
            >
              <img
                src="content/architect2/images/slider_3_automate.jpg"
                title="home_architect2_slider2"
                width={1920}
                height={800}
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                className="rev-slidebg"
              />
              <div
                className="tp-caption   tp-resizeme"
                id="slide-2-layer-2"
                data-x="right"
                data-hoffset={50}
                data-y=""
                data-width="['auto']"
                data-height="['auto']"
                data-transform_idle="o:1;"
                data-transform_in="x:right;s:700;e:Power2.easeInOut;"
                data-transform_out="opacity:0;s:300;"
                data-start={700}
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style={{
                  zIndex: 5,
                  whiteSpace: "nowrap",
                  fontSize: 28,
                  lineHeight: 50,
                  fontWeight: 700,
                  color: "rgba(255, 255, 255, 1.00)",
                  fontFamily: "Raleway",
                  backgroundColor: "rgba(0, 0, 0, 1.00)",
                  padding: "0 20px 0px 20px",
                }}
              >
                AUTOMATISERING
              </div>
            </li>
            <li
              data-index="rs-4"
              data-transition="fade"
              data-slotamount="default"
              data-hideafterloop={0}
              data-hideslideonmobile="off"
              data-easein="default"
              data-easeout="default"
              data-masterspeed={300}
              data-rotate={0}
              data-saveperformance="off"
              data-title="Slide"
              data-param1=""
              data-param2=""
              data-param3=""
              data-param4=""
              data-param5=""
              data-param6=""
              data-param7=""
              data-param8=""
              data-param9=""
              data-param10=""
              data-description=""
            >
              <img
                src="content/architect2/images/slider_4_teksten.jpg"
                title="home_architect2_slider2"
                width={1920}
                height={800}
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                className="rev-slidebg"
              />
              <div
                className="tp-caption   tp-resizeme"
                id="slide-2-layer-2"
                data-x="right"
                data-hoffset={50}
                data-y=""
                data-width="['auto']"
                data-height="['auto']"
                data-transform_idle="o:1;"
                data-transform_in="x:right;s:700;e:Power2.easeInOut;"
                data-transform_out="opacity:0;s:300;"
                data-start={700}
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style={{
                  zIndex: 5,
                  whiteSpace: "nowrap",
                  fontSize: 28,
                  lineHeight: 50,
                  fontWeight: 700,
                  color: "rgba(255, 255, 255, 1.00)",
                  fontFamily: "Raleway",
                  backgroundColor: "rgba(0, 0, 0, 1.00)",
                  padding: "0 20px 0px 20px",
                }}
              >
                COMMERCIËLE TEKSTEN
              </div>
            </li>
            <li
              data-index="rs-5"
              data-transition="fade"
              data-slotamount="default"
              data-hideafterloop={0}
              data-hideslideonmobile="off"
              data-easein="default"
              data-easeout="default"
              data-masterspeed={300}
              data-rotate={0}
              data-saveperformance="off"
              data-title="Slide"
              data-param1=""
              data-param2=""
              data-param3=""
              data-param4=""
              data-param5=""
              data-param6=""
              data-param7=""
              data-param8=""
              data-param9=""
              data-param10=""
              data-description=""
            >
              <img
                src="content/architect2/images/webdesign_5_slider.jpg"
                title="home_architect2_slider2"
                width={1920}
                height={800}
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                className="rev-slidebg"
              />
              <div
                className="tp-caption   tp-resizeme"
                id="slide-2-layer-2"
                data-x="right"
                data-hoffset={50}
                data-y=""
                data-width="['auto']"
                data-height="['auto']"
                data-transform_idle="o:1;"
                data-transform_in="x:right;s:700;e:Power2.easeInOut;"
                data-transform_out="opacity:0;s:300;"
                data-start={700}
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style={{
                  zIndex: 5,
                  whiteSpace: "nowrap",
                  fontSize: 28,
                  lineHeight: 50,
                  fontWeight: 700,
                  color: "rgba(255, 255, 255, 1.00)",
                  fontFamily: "Raleway",
                  backgroundColor: "rgba(0, 0, 0, 1.00)",
                  padding: "0 20px 0px 20px",
                }}
              >
                IT-OPLOSSINGSEXPERT
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Slider;
